const dashboard = () => {
  const quicknews = document.getElementById('quicknews');
  const newsfeed = document.getElementById('newsfeed');
  const survey = document.getElementById('survey');
  if (quicknews && newsfeed) {
    let height = 0;
    height += newsfeed.offsetHeight;
    if (survey) {
      height += survey.offsetHeight;
    }

    quicknews.style.maxHeight = `${height}px`;
  }
};

dashboard();
